<template>
  <div class="modules flex md:flex-row flex-col justify-center">
    <div class="relative md:min-w-xxs z-40">
      <div class="sticky top-5 mt-8 md:mt-10 lg:mt-36 md:max-w-1/6 pl-8">
        <h2 class="font-serif text-4xl font-bold text-primary-900 tracking-wide">Módulos</h2>
        <div class="self-start w-16 h-1 bg-secondary-600 mb-3"></div>
        <ul @click="openMenuXs = !openMenuXs" class="relative interlinea w-11/12 font-sans text-primary-600 navmodules border-b md:border-none border-solid border-primary-700">
          <router-link class="cursor-pointer text-xl md:text-base" tag="li" :to="{ name: 'landmodules'}">Introducción</router-link>
          <router-link class="cursor-pointer text-xl md:text-base" tag="li" :to="{ name: 'elements'}">Elementos constructivos</router-link>
          <router-link class="cursor-pointer text-xl md:text-base" tag="li" :to="{ name: 'materials'}">Materiales constructivos</router-link>
          <router-link class="cursor-pointer text-xl md:text-base" tag="li" :to="{ name: 'alteraciones'}">Alteración</router-link>
          <router-link class="cursor-pointer text-xl md:text-base" tag="li" :to="{ name: 'phases'}">Fases constructivas</router-link>
          <router-link class="cursor-pointer text-xl md:text-base" tag="li" :to="{ name: 'humidities'}">Humedades</router-link>
          <router-link class="cursor-pointer text-xl md:text-base" tag="li" :to="{ name: 'intervention'}">Intervención</router-link>
          <router-link class="cursor-pointer text-xl md:text-base" tag="li" :to="{ name: 'maintenance'}">Mantenimiento</router-link>
          <router-link class="cursor-pointer text-xl md:text-base" tag="li" :to="{ name: 'archeology'}">Arqueología</router-link>
          <router-link class="cursor-pointer text-xl md:text-base" tag="li" :to="{ name: 'deformation'}">Deformación</router-link>
          <router-link class="cursor-pointer text-xl md:text-base" tag="li" :to="{ name: 'sampling'}">Muestreo</router-link>
          <router-link class="cursor-pointer text-xl md:text-base" tag="li" :to="{ name: 'coatings'}">Patinas y recubrimientos</router-link>
          <span class="md:hidden arrow-menu-modules absolute right-0 top-3" :class="{'modules-opened':openMenuXs}"></span>
        </ul>
        <transition name="collapse">
          <ul v-show="openMenuXs" @click="openMenuXs = !openMenuXs" class="interlinea w-full font-sans text-primary-600 navmodules navmodules-xs absolute z-50 bg-white px-20 left-0 py-4">
            <router-link class="cursor-pointer" tag="li" :to="{ name: 'landmodules'}">Introducción</router-link>
            <router-link class="cursor-pointer" tag="li" :to="{ name: 'elements'}">Elementos constructivos</router-link>
            <router-link class="cursor-pointer" tag="li" :to="{ name: 'materials'}">Materiales constructivos</router-link>
            <router-link class="cursor-pointer" tag="li" :to="{ name: 'alteraciones'}">Alteración</router-link>
            <router-link class="cursor-pointer" tag="li" :to="{ name: 'phases'}">Fases constructivas</router-link>
            <router-link class="cursor-pointer" tag="li" :to="{ name: 'humidities'}">Humedades</router-link>
            <router-link class="cursor-pointer" tag="li" :to="{ name: 'intervention'}">Intervención</router-link>
            <router-link class="cursor-pointer" tag="li" :to="{ name: 'maintenance'}">Mantenimiento</router-link>
            <router-link class="cursor-pointer" tag="li" :to="{ name: 'archeology'}">Arqueología</router-link>
            <router-link class="cursor-pointer" tag="li" :to="{ name: 'deformation'}">Deformación</router-link>
            <router-link class="cursor-pointer" tag="li" :to="{ name: 'sampling'}">Muestreo</router-link>
            <router-link class="cursor-pointer" tag="li" :to="{ name: 'coatings'}">Patinas y recubrimientos</router-link>
          </ul>
        </transition>
      </div>
    </div>
    <div class="overflow-hidden max-w-6xl w-11/12 mr-4">
      <router-view class="mx-auto w-full max-w-11/12"></router-view>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      openMenuXs: false
    }
  }
}
</script>
